export const MIN_STAY_ERROR = 1
export const MAX_STAY_ERROR = 2
export const NO_CHECK_IN_ERROR = 3
export const NO_CHECK_OUT_ERROR = 4
export const MIN_ADVANCE_RESERVATION_ERROR = 5
export const MAX_ADVANCE_RESERVATION_ERROR = 6
export const MIN_STAY_ARRIVAL_ERROR = 7
export const MAX_STAY_ARRIVAL_ERROR = 8
export const CLOSED_ERROR = 9
